import React from 'react';
import { NovaUnifiedPageBar } from './NovaUnified';

const FONT_BODY = "'Plus Jakarta Sans', -apple-system, sans-serif";

/**
 * Sticky top Nova bar — same anatomy as NovaUnifiedPageBar inline + dismiss.
 */
export default function NovaPresenceBar({ contextPill = 'Guidance', message, actionLabel, onAction, onDismiss }) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        fontFamily: FONT_BODY,
        flexShrink: 0,
        boxSizing: 'border-box',
        borderBottom: '0.5px solid rgba(212, 83, 126, 0.2)',
        padding:
          '8px max(16px, env(safe-area-inset-right, 0px)) 8px max(16px, env(safe-area-inset-left, 0px))',
      }}
    >
      <NovaUnifiedPageBar
        layout="inline"
        contextPill={contextPill}
        body={message}
        actionLabel={actionLabel}
        onAction={onAction}
        trailingAfterAction={
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            style={{
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'none',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              color: 'var(--muted)',
              fontSize: 16,
              lineHeight: 1,
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.06)';
              e.currentTarget.style.color = 'var(--text)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
              e.currentTarget.style.color = 'var(--muted)';
            }}
          >
            ×
          </button>
        }
      />
    </div>
  );
}
